import Hero from "../components/sections/Hero";
import FlagshipStrip from "../components/sections/FlagshipStrip";
import CoreServices from "../components/sections/CoreServices";
import WhyUs from "../components/sections/WhyUs";
import Process from "../components/sections/Process";
import CommonProblems from "../components/sections/CommonProblems";
import CompleteSolutions from "../components/sections/CompleteSolutions";
import ProjectShowcase from "../components/sections/ProjectShowcase";
import ServiceArea from "../components/sections/ServiceArea";
import CTASection from "../components/sections/CTASection";
import FAQ from "../components/sections/FAQ";
import ContactForm from "../components/sections/ContactForm";

export default function Home() {
  return (
    <>
      <Hero />
      <FlagshipStrip />
      <CoreServices />
      <WhyUs />
      <Process />
      <CommonProblems />
      <ProjectShowcase limit={8} />
      <CompleteSolutions />

      {/* Material & Quality note */}
      <section
        data-testid="material-quality"
        className="py-20 md:py-32 bg-ink-mist border-t border-ink-line"
      >
        <div className="max-w-[1200px] mx-auto px-5 md:px-8 grid grid-cols-1 md:grid-cols-12 gap-8">
          <div className="md:col-span-6">
            <div className="font-mono text-[11px] tracking-[0.25em] uppercase text-ink-muted mb-5">
              Material &amp; Quality
            </div>
            <h2 className="font-display text-3xl md:text-5xl text-ink leading-tight tracking-[-0.03em]">
              Quality work starts with
              <br />
              <span className="font-serif-italic font-normal text-ink-mid">
                proper preparation.
              </span>
            </h2>
          </div>
          <div className="md:col-span-6 space-y-4 text-ink-mid leading-relaxed">
            <p>
              The correct material and application method depends on multiple
              factors — the actual condition of the surface, moisture level,
              weather exposure, expected usage, existing coating, area to be
              covered, required durability and the desired finish.
            </p>
            <p className="text-ink-muted">
              No single product or system is suitable for every project. That
              is why we begin every job with a proper site inspection and
              assessment before recommending a solution.
            </p>
            <ul className="pt-4 grid grid-cols-2 gap-x-6 gap-y-2 font-mono text-xs tracking-wide text-ink-muted">
              {[
                "Surface condition",
                "Moisture",
                "Weather exposure",
                "Usage",
                "Existing coating",
                "Area",
                "Required durability",
                "Desired finish",
              ].map((x) => (
                <li key={x} className="flex items-center gap-2">
                  <span className="w-1 h-1 bg-ink" /> {x}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <ServiceArea />
      <CTASection />
      <FAQ />

      {/* Lead form */}
      <section
        id="request-inspection"
        data-testid="home-form-section"
        className="py-20 md:py-32 bg-white border-t border-ink-line"
      >
        <div className="max-w-4xl mx-auto px-5 md:px-8">
          <ContactForm source="home_form" />
        </div>
      </section>
    </>
  );
}
